"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const helper_1 = require("../reviews/helper");
const asset_detail_drawer_1 = __importDefault(require("./components/asset-detail-drawer"));
const store_1 = __importDefault(require("./store/store"));
require("./styles/styles.less");
const CONTENT = (helper_1.REQUEST === null || helper_1.REQUEST === void 0 ? void 0 : helper_1.REQUEST.content) || '';
const PulseAssetDetail = (0, react_1.forwardRef)((props, ref) => {
    const { mineUploadForm, initialState, ...restProps } = props;
    (0, react_1.useEffect)(() => {
        return () => {
            if (window.Echo) {
                window.Echo.leaveChannel('ziflow-asset-detail');
            }
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_redux_1.Provider, { store: (0, store_1.default)(initialState) },
            react_1.default.createElement(asset_detail_drawer_1.default, { ref: ref, ...restProps })),
        react_1.default.createElement("div", { id: "open-asset-detail" })));
});
PulseAssetDetail.displayName = 'PulseAssetDetail';
exports.default = PulseAssetDetail;
